import { get } from 'lodash';
import * as C from 'actions/constants';

export const blankState = {
  loading: false,
  data: {},
};

const defaultWidgetData = {
  data: [],
  baseFilters: {},
  title: null,
  type: null,
  taskIdentifier: null,
  description: null,
  orderId: null,
  feedbacks: [],
  feedbacksCount: null,
  groupBy: null,
  chartType: null,
  loading: true,
  error: false,
};

const setWidget = (state, id, widgetData) => {
  const { data } = state;
  return {
    ...data,
    [id]: {

      ...defaultWidgetData,
      ...get(data, id, {}),
      ...widgetData,
    },
  };
};

const WidgetsReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_WIDGETS_LIST: {
      return { ...state, loading: true };
    }
    case C.LOAD_WIDGET_DATA:
    case C.UPDATE_WIDGET:
    case C.LOAD_WIDGET_FEEDBACKS: {
      const { data: { id } } = action;
      return { ...state, data: setWidget(state, id, { loading: true }) };
    }
    case C.LOAD_WIDGETS_LIST_SUCCESS: {
      const { data } = action;
      const nextState = data.reduce(
        (acc, d) => (
          {
            ...state,
            data: setWidget(acc, d.id, Object.assign(d, {
              initialGroupBy: d.groupBy,
              initialChartType: d.chartType,
            })),
          }
        ),
        state,
      );
      return { ...state, ...nextState, loading: false };
    }
    case C.LOAD_WIDGET_DATA_SUCCESS: {
      const {
        data: {
          id,
          data,
          meta,
          groupBy,
          chartType,
        },
      } = action;
      return {
        ...state,
        data: setWidget(state, id, {
          data,
          meta,
          groupBy,
          chartType,
          loading: false,
        }),
      };
    }
    case C.LOAD_WIDGET_FEEDBACKS_SUCCESS: {
      const { data: { id, feedbacks } } = action;
      return { ...state, data: setWidget(state, id, { feedbacks, loading: false }) };
    }
    case C.UPDATE_WIDGET_SUCCESS: {
      const { data, data: { id, groupBy, chartType } } = action;

      return {
        ...state,
        data: setWidget(state, id, {
          ...data,
          initialGroupBy: groupBy,
          initialChartType: chartType,
          loading: false,
        }),
      };
    }
    case C.LOAD_WIDGETS_LIST_ERROR: {
      return { ...state, loading: false };
    }
    case C.LOAD_WIDGET_DATA_ERROR:
    case C.LOAD_WIDGET_FEEDBACKS_ERROR: {
      const { data: { id } } = action;
      return { ...state, data: setWidget(state, id, { loading: false, error: true }) };
    }
    case C.CLOSE_REPORT: {
      return blankState;
    }
    default:
      return state;
  }
};

export default WidgetsReducer;
